import _jsx from '@babel/runtime/helpers/esm/jsx';
import { memo, useCallback } from 'react';
import SmartSection from '@dbh/smart-section';
import { makeSelectWebcontrolsLoaded } from '@dbh/webcontrols-redux';
import { useMakeSelect } from '@dbh/reselect-extra';

const LinksSection=/*#__PURE__*/memo(a=>{let{useImageLazyLoading:b,makeSelectWebcontrolsLinksData:c}=a;const d=useMakeSelect(makeSelectWebcontrolsLoaded),e=useMakeSelect(c),f=useCallback(()=>/*#__PURE__*/_jsx(SmartSection,{elements:e.get("root"),links:e.get("links"),title:e.get("headingText"),htmlTag:e.get("htmlTag")}),[e]);return d&&e?b?f():f():void 0});LinksSection.displayName="LinksSection";

export { LinksSection as default };
